import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import MUIDataTable from "mui-datatables";
import AppContext from "../../container/context";
import { mergeParams } from "../../helpers/helpers";

let totais = {
  valorTotal: 0,
  recebido: 0,
  aReceber: 0,
  vencido: 0,
};

export default function RelatorioPagamentos({ history, location }) {
  const { notification } = useContext(AppContext);

  const [registrosVencidos, setRegistrosVencidos] = useState([]);
  const [registrosAReceber, setRegistrosAReceber] = useState([]);
  const [registrosRecebidos, setRegistrosRecebidos] = useState([]);
  const [dataAtual] = useState(new Date());
  const [dadosFiltros, setDadosFiltros] = useState(
    mergeParams(
      {
        anoInicio: dataAtual.getFullYear(),
        anoFim: dataAtual.getFullYear(),
        mesInicio: 1,
        mesFim: 12,
        // emAtraso: false,
      },
      location
    )
  );

  useEffect(() => {
    carregarRelatorio();
  }, []);

  const carregarRelatorio = (filtrosEnviar = dadosFiltros) => {
    setDadosFiltros(filtrosEnviar);
    api
      .get("relatorios/pagamentos", filtrosEnviar)
      .then((registros) => {
        let valorTotal = 0;
        let recebido = 0;
        let aReceber = 0;
        let vencido = 0;

        const rRecebidos = [];
        const rAReceber = [];
        const rVencidos = [];

        registros.forEach((r) => {
          valorTotal += r.pedidoPagamentoValor;

          r.valorPagamento = (r.pedidoPagamentoValor / 100).toLocaleString(
            "pt-BR",
            { style: "currency", currency: "BRL" }
          );
          r.mesAnoFatura = `${r.pedidoPagamentoVencimentoMes}/${r.pedidoPagamentoVencimentoAno}`;
          r.dataReferenciaPagamento = new Date(
            r.dataReferenciaPagamento
          ).toLocaleDateString("pt-BR");

          if (r.faturaPagamento) {
            recebido += r.pedidoPagamentoValor;

            rRecebidos.push(r);
            r.situacao = "Pago";
          } else {
            if (r.emAtraso) {
              vencido += r.pedidoPagamentoValor;

              rVencidos.push(r);
              r.situacao = "Atrasado";
            } else {
              aReceber += r.pedidoPagamentoValor;

              rAReceber.push(r);
              r.situacao = "Pendente";
            }
          }
        });

        if (filtrosEnviar.emAtraso)
          registros = registros.filter((r) => !r.faturaPagamento);

        totais = {
          valorTotal,
          recebido,
          aReceber,
          vencido,
        };
        setRegistrosVencidos(rVencidos);
        setRegistrosAReceber(rAReceber);
        setRegistrosRecebidos(rRecebidos);
      })
      .catch((e) => {
        notification("error", "Erro ao carregar o relatório");
      });
  };

  const fFiltros = {
    title: "Período",
    form: {
      mesInicio: {
        label: "Mês início",
        type: "number",
        space: 2,
        value: dadosFiltros.mesInicio,
      },
      anoInicio: {
        label: "Ano início",
        type: "number",
        space: 4,
        value: dadosFiltros.anoInicio,
      },
      mesFim: {
        label: "Mês fim",
        type: "number",
        space: 2,
        value: dadosFiltros.mesFim,
      },
      anoFim: {
        label: "Ano fim",
        type: "number",
        space: 4,
        value: dadosFiltros.anoFim,
      },
      // emAtraso: {
      //   label: "Pagamentos não recebidos",
      //   type: "check",
      //   space: 2,
      //   value: dadosFiltros.emAtraso,
      // },
    },

    submit: {
      label: "Carregar",
      action: carregarRelatorio,
    },

    urlParams: true,
    history,
    location,
  };

  const fTotais = {
    title: "Totais",
    form: {
      total: {
        label: "Valor total",
        type: "text",
        space: 3,
        readOnly: true,
        value: (totais.valorTotal / 100).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
      },
      recebido: {
        label: "Recebido",
        type: "text",
        space: 3,
        readOnly: true,
        value: (totais.recebido / 100).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
      },
      aReceber: {
        label: "A receber (no prazo)",
        type: "text",
        space: 3,
        readOnly: true,
        value: (totais.aReceber / 100).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
      },
      vencido: {
        label: "A receber (vencido)",
        type: "text",
        space: 3,
        readOnly: true,
        value: (totais.vencido / 100).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
      },
    },
  };

  return (
    <div>
      <Form formData={fFiltros} />
      <Form formData={fTotais} />
      <br />
      {registrosVencidos.length > 0 && (
        <>
          <MUIDataTable
            title="Pagamentos a receber (vencidos)"
            data={registrosVencidos}
            columns={columns}
            options={options}
          />
          <div
            style={{
              marginTop: 15,
              marginBottom: 15,
              padding: 15,
              color: "black",
              backgroundColor: "#ff918a",
            }}
          >
            <h4>Total a receber (vencidos)</h4>
            {(totais.vencido / 100).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </div>
        </>
      )}

      {registrosAReceber.length > 0 && (
        <>
          <MUIDataTable
            title="Pagamentos a receber (no prazo)"
            data={registrosAReceber}
            columns={columns}
            options={options}
          />
          <div
            style={{
              marginTop: 15,
              marginBottom: 15,
              padding: 15,
              color: "black",
              backgroundColor: "#fffaa3",
            }}
          >
            <h4>Total a receber (no prazo)</h4>
            {(totais.aReceber / 100).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </div>
        </>
      )}

      {registrosRecebidos.length > 0 && (
        <>
          <MUIDataTable
            title="Pagamentos recebidos"
            data={registrosRecebidos}
            columns={columns}
            options={options}
          />
          <div
            style={{
              marginTop: 15,
              marginBottom: 15,
              padding: 15,
              color: "black",
              backgroundColor: "#99ff9e",
            }}
          >
            <h4>Total recebido</h4>
            {(totais.recebido / 100).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </div>
        </>
      )}
    </div>
  );
}

const columns = [
  {
    name: "pedidoId",
    label: "Cód. pedido",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "valorPagamento",
    label: "Valor",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "pedidoPagamentoParcelaNumero",
    label: "Nº parcela",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "mesAnoFatura",
    label: "Mês/ano fatura",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "dataReferenciaPagamento",
    label: "Data referência para pagamento",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "escolaNomeFantasia",
    label: "Escola",
    options: {
      filter: false,
      sort: false,
    },
  },
];

const options = {
  filterType: "checkbox",
  selectableRows: "none",
  rowsPerPage: 50,
  downloadOptions: {
    filename: "cadastros.csv",
    separator: ";",
    filterOptions: {
      useDisplayedColumnsOnly: false,
      useDisplayedRowsOnly: true,
    },
  },
};
